// @flow
const notificationPermissions = {
    /*eslint-disable */
    DEFAULT: 'default',
    DENIED: 'denied',
    GRANTED: 'granted',
    UNSUPPORTED: 'unsupported',
    /*eslint-enable */
};

export default notificationPermissions;
